import React from "react";
import JobForm from "./JobForm";

function App() {
  return (
    <div>
      <JobForm />
    </div>
  );
}

export default App;
